import React from 'react';
import _ListSocial from './_ListSocial.scss';

class ListSocialLeft extends React.Component {

  render() {
    return (
      <div className="list-social">
        <a target="_blank" href="#"><img alt="Đã đăng ký Bộ Công Thương" title="" src={require('assets/images/footer/tick-dky.png')} height="100"/></a>
      </div>
    );
  }
}
export default ListSocialLeft;



// WEBPACK FOOTER //
// ./components/layouts/master/sub-footer/ListSocialLeft.jsx